(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ---------- Desktop mega menu hover behavior ---------- */
  if (window.matchMedia('(min-width: 990px)').matches) {
    let currentOpen = null;

    document.querySelectorAll('.header__inline-menu > ul > li > header-menu > details').forEach((details) => {
      const summary = details.querySelector('summary');
      const content = details.querySelector('.mega-menu__content, .header__submenu');
      let closeTimer = null;
      let clickImmune = false;

      function openMenu() {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }

        if (currentOpen && currentOpen !== details) {
          currentOpen.removeAttribute('open');
          const prevSummary = currentOpen.querySelector('summary');
          if (prevSummary) prevSummary.setAttribute('aria-expanded', 'false');
        }

        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
        currentOpen = details;
      }

      function scheduleClose() {
        if (clickImmune) return;
        closeTimer = setTimeout(() => {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
          if (currentOpen === details) currentOpen = null;
        }, 200);
      }

      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mouseleave', scheduleClose);

      if (content) {
        content.addEventListener('mouseenter', () => {
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        });
        content.addEventListener('mouseleave', scheduleClose);
        content.addEventListener('click', () => {
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
          clickImmune = true;
          setTimeout(() => { clickImmune = false; }, 400);
        });
      }

      summary.addEventListener('click', (e) => {
        if (window.innerWidth >= 990) {
          var anchor = e.target.closest('a');
          if (anchor) {
            return;
          }
          e.preventDefault();
        }
      });
    });

    /* Keyboard: Escape closes the open panel */
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && currentOpen) {
        const summary = currentOpen.querySelector('summary');
        currentOpen.removeAttribute('open');
        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
          summary.focus();
        }
        currentOpen = null;
      }
    });
  }

  /* ---------- Product carousel web component (multi-track + external arrows) ---------- */
  class MegaMenuCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.mega-menu__carousel-viewport');
      this.tracks = [...this.querySelectorAll('.mega-menu__carousel-track')];
      this.prevBtn = this.querySelector('.mega-menu__arrow--prev');
      this.nextBtn = this.querySelector('.mega-menu__arrow--next');

      if (!this.viewport || !this.tracks.length) return;

      this.visible = parseInt(this.getAttribute('data-visible') || '4', 10);
      this.activeTrack = this.tracks.find(t => !t.hidden) || this.tracks[0];
      this.offset = 0;

      if (this.prevBtn && this.nextBtn) {
        this.prevBtn.addEventListener('click', () => this.slide(-1));
        this.nextBtn.addEventListener('click', () => this.slide(1));
      }

      this.positionArrows();
      this.updateButtons();
      this.setupHoverSwap();
    }

    setupHoverSwap() {
      const panel = this.closest('.mega-menu__inner');
      if (!panel) return;

      const links = panel.querySelectorAll('.mega-menu__link[data-submenu-index]');
      links.forEach(link => {
        link.addEventListener('mouseenter', () => {
          const idx = link.getAttribute('data-submenu-index');
          this.switchTrack(idx);

          links.forEach(l => l.classList.remove('mega-menu__link--hover-active'));
          link.classList.add('mega-menu__link--hover-active');
        });
      });
    }

    switchTrack(index) {
      const target = this.tracks.find(t => t.dataset.submenuIndex === index);
      if (!target || target === this.activeTrack) return;

      this.tracks.forEach(track => {
        if (track.dataset.submenuIndex === index) {
          track.hidden = false;
          track.style.transform = '';
        } else {
          track.hidden = true;
          track.style.transform = '';
        }
      });

      this.activeTrack = target;
      this.offset = 0;
      this.updateButtons();
      this.positionArrows();
    }

    positionArrows() {
      const img = this.activeTrack ? this.activeTrack.querySelector('.mega-menu__product-img-wrap') : null;
      if (img) {
        requestAnimationFrame(() => {
          const center = img.offsetHeight / 2;
          if (center > 0) {
            this.style.setProperty('--arrow-top', center + 'px');
          }
        });
      }
    }

    slide(dir) {
      if (!this.activeTrack) return;
      const cards = [...this.activeTrack.children];
      const maxOffset = Math.max(0, cards.length - this.visible);
      this.offset = Math.min(Math.max(this.offset + dir, 0), maxOffset);

      const card = cards[0];
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.activeTrack).gap) || 16;
      const shift = this.offset * (card.offsetWidth + gap);
      this.activeTrack.style.transform = `translateX(-${shift}px)`;
      this.updateButtons();
    }

    updateButtons() {
      if (!this.prevBtn || !this.nextBtn || !this.activeTrack) return;
      const cards = [...this.activeTrack.children];
      const maxOffset = Math.max(0, cards.length - this.visible);

      this.prevBtn.disabled = this.offset <= 0;
      this.nextBtn.disabled = this.offset >= maxOffset;

      const showArrows = cards.length > this.visible;
      this.prevBtn.style.display = showArrows ? '' : 'none';
      this.nextBtn.style.display = showArrows ? '' : 'none';
    }
  }

  customElements.define('mega-menu-carousel', MegaMenuCarousel);

  } catch(e) { console.error(e); }
})();
})();
